import React from 'react';
import { useNavigate } from 'react-router-dom';
import logoIcon from '../assets/logo-icon-exact.png';
import Footer from '../components/Footer';

function Welcome({ session, darkMode, toggleDark }) {
  const navigate = useNavigate();

  return (
    <div className="auth-page">
      <header>
        <div className="logo" onClick={() => navigate('/')}>
          <div className="logo-icon"><img src={logoIcon} alt="" /></div>
          <div className="logo-text">TradeReady<span> Pro</span></div>
        </div>
        <div className="header-right">
          <button className="dark-toggle" onClick={toggleDark}>
            <span>{darkMode ? '☀️' : '🌙'}</span>
            <span>{darkMode ? 'Light' : 'Dark'}</span>
          </button>
        </div>

      </header>

      <div className="auth-wrap">
        <div className="auth-card" style={{ textAlign: 'center', maxWidth: 480 }}>
          <div style={{ fontSize: '3rem', marginBottom: '0.5rem' }}>🎉</div>
          <h2 style={{ marginBottom: '0.5rem' }}>Welcome to TradeReady Pro!</h2>
          <p className="auth-sub" style={{ marginBottom: '1.5rem' }}>
            Your subscription is active. You now have full access to everything.
          </p>

          <div style={{
            background: 'rgba(201,168,76,0.08)',
            border: '1px solid rgba(201,168,76,0.25)',
            borderRadius: '0.75rem',
            padding: '1.25rem',
            marginBottom: '1.75rem',
            textAlign: 'left',
          }}>
            <div style={{ fontWeight: 600, color: 'var(--gold)', marginBottom: '0.75rem', fontSize: '0.9rem' }}>
              What you've unlocked:
            </div>
            {[
              ['⚡', 'All 2,093+ electrical exam-style questions'],
              ['🔧', 'Electrician and Industrial Millwright tracks'],
              ['🔀', 'Randomized quizzes — never the same twice'],
              ['📊', 'Progress tracking & score history'],
            ].map(([icon, text]) => (
              <div key={text} style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '0.5rem', fontSize: '0.9rem' }}>
                <span>{icon}</span>
                <span>{text}</span>
              </div>
            ))}
          </div>

          <button
            className="btn-auth"
            style={{ width: '100%', marginBottom: '0.75rem', cursor: 'pointer', border: 'none' }}
            onClick={() => navigate('/quiz')}
          >
            Start Quizzing →
          </button>

          <button
            className="btn-auth"
            style={{
              width: '100%',
              cursor: 'pointer',
              background: 'transparent',
              border: '1px solid var(--gold)',
              color: 'var(--gold)',
            }}
            onClick={() => navigate('/dashboard')}
          >
            View My Dashboard
          </button>

          {session?.user?.email && (
            <div style={{ marginTop: '1.25rem', fontSize: '0.78rem', opacity: 0.5 }}>
              Signed in as {session.user.email}
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Welcome;
